import { useOutlet } from "react-router-dom";
import { Footer } from "./Footer";
import { Header } from "./Header";
import "./Layout.scss";

export const Layout = ({ languageId, setLanguageId }) => {
  const outlet = useOutlet();

  return (
    <>
      <Header languageId={languageId} setLanguageId={setLanguageId} />
      {outlet}
      <Footer languageId={languageId} />
    </>
  );
};
